import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import './Timeout.css';
import eventConfig, { eventHeadline } from '../eventConfig';

class Timeout extends Component {
  render() {
    return (
      <Container className="video-center" >
          <Col md={4}>
         <p className='mt-96 '/>
          <Container className="text-button-container">
          <p className="video-text-main"><b>{eventHeadline}</b></p>
          <p className="video-text">
          Pojď na <b> Fakultu podnikatelskou VUT </b> navázat kontakt s personalisty z bezmála 50 firem, prohlédni si otevřené pozice a zjisti více o zaměstnání ve svém oboru.
          </p>
          <div className="button-main">
          <AddToCalendarButton
            name={eventConfig.name}
            label="Přidat do kalendáře!"
            size="15"
            lightMode="light"
            startDate={eventConfig.isoDate}
            location={eventConfig.locationFull}
            options="['Google', 'Apple', 'iCal']"
          ></AddToCalendarButton>
          </div>
          </Container>
          </Col>
       </Container>
    );
  }
}

export default Timeout;
